import { useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";

import { Layout, Menu } from "antd";
import type { MenuProps } from "antd/es/menu";
// import Logo from "./../../assets/pngs/logo/Logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import TitleContext from "../../context/TitleContext";
import { AppRoutes } from "../../data";
import DashboardPage from "../../pages/DashboardPage";
import Logo from "./../../assets/svgs/Logo/netwala-light.png";
import PageTitle from "./CurrentPageTitle";
import ExpenseIcon from "./../../assets/svgs/MenuIcons/ExpenseIcon.svg";
import ExpenseIconBlue from "./../../assets/svgs/MenuIcons/ExpenseIconBlue.svg";
import "./layout.css";
import TopNavBar from "./TopNav";
const { Sider, Header, Content } = Layout;
type MenuItem = Required<MenuProps>["items"][number];

const AppLayout = () => {
  const { title } = useContext(TitleContext);
  const isLoggedIn = localStorage.getItem("auth_token") || false;
  const [items, setItems] = useState<MenuItem[]>([]);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const routes = AppRoutes();
    const visibleRoutes = routes.filter((item: any) => item.show === true);

    // Group routes by parent
    const childRoutes = visibleRoutes.filter((item: any) => item.parentPath);
    const parentRoutesMap = new Map();

    // Create parent entries from child routes
    childRoutes.forEach((child: any) => {
      if (!parentRoutesMap.has(child.parentPath)) {
        // Find a parent route or create a virtual one
        const parentRoute = routes.find(
          (r: any) => r.path === child.parentPath,
        );
        if (parentRoute) {
          parentRoutesMap.set(child.parentPath, {
            ...parentRoute,
            children: [],
          });
        } else {
          // Create virtual parent
          parentRoutesMap.set(child.parentPath, {
            path: child.parentPath,
            text: "Reports",
            icon: ExpenseIcon,
            activeIcon: ExpenseIconBlue,
            children: [],
          });
        }
      }
      parentRoutesMap.get(child.parentPath).children.push(child);
    });

    // Build menu items
    const _items: MenuItem[] = [];

    // Add regular items without parents first
    const regularItems = visibleRoutes.filter((item: any) => !item.parentPath);
    regularItems.forEach((item: any) => {
      _items.push({
        key: item.path,
        icon: (
          <img
            src={location.pathname === item.path ? item.activeIcon : item.icon}
          />
        ),
        label: <span style={{ fontWeight: "bold" }}>{item.text}</span>,
      });
    });

    // Add parent items with children at the end
    parentRoutesMap.forEach((parent: any) => {
      // Check if any child is currently selected (not just if pathname starts with parent path)
      const hasSelectedChild = parent.children.some(
        (child: any) => location.pathname === child.path,
      );
      _items.push({
        key: parent.path,
        icon: <img src={hasSelectedChild ? parent.activeIcon : parent.icon} />,
        label: <span style={{ fontWeight: "bold" }}>{parent.text}</span>,
        children: parent.children.map((child: any) => ({
          key: child.path,
          label: <span style={{ fontWeight: "bold" }}>{child.text}</span>,
        })),
      });
    });

    setItems(_items);
  }, [location]);

  const [routes, setRoutes] = useState<any>([]);

  useEffect(() => {
    setRoutes(AppRoutes());
  }, []);

  return (
    <>
      <Layout>
        <Header
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0px",
            height: "120px",
            background: "white",
            position: "sticky",
            top: 0,
            zIndex: 1000,
            width: "100%",
          }}
        >
          <div className="top-nav-bar-custom">
            <div className="logo ">
              <img src={Logo} alt="Logo" className="cursor-pointer" />
              {/* {activePageTitle !== null ? (
                <PageTitle title={activePageTitle} />
              ) : null} */}
            </div>
            <div className="top-nav-sub-item">
              <PageTitle title={title} />
              <TopNavBar />
            </div>
          </div>
        </Header>
        <Layout>
          <Sider className="side-bar-main" width={250}>
            <Menu
              mode="inline"
              selectedKeys={[location.pathname]}
              onClick={(e) => {
                navigate(e.key);
              }}
              defaultOpenKeys={["sub1"]}
              style={{
                position:"fixed",
                height: "100%",
                borderRight: 0,
                width: "250px",
                marginTop: "0px",
                   maxHeight: "calc(100% - 120px)",
                overflowY:"auto", 
              }}
              defaultSelectedKeys={["1"]}
              items={items}
              className="side-bar-menu-items-container"
              // theme={theme}
            />

          </Sider>
          <Layout style={{ padding: "0 24px 24px", background: "#F3F6FF",minHeight:"100vh" }}>
            <Content
              style={{
                padding: 24,
                margin: 0,
                minHeight: 280,
              }}
            >
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                {isLoggedIn &&
                  routes.map((route: any) => {
                    return (
                      <Route
                        path={route.path}
                        key={Math.random()}
                        element={<route.Component />}
                      />
                    );
                  })}
              </Routes>
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </>
  );
};

export default AppLayout;
